import React, { useEffect, useState } from "react";
import { getUserDept, getUserDetails } from "./apis/userApis";
import { getCookiesSession, setCookiesSession } from "./cookiesSession";

const Home = ({ children, setUserData }) => {
  const [config, setConfig] = useState({ Loading: true });

  useEffect(() => {
    const cookieData = getCookiesSession("LawSignaUserDataMaster");

    const getDetails = async () => {
      try {
        console.log("Calling getUserDetails");
        const response = await getUserDetails();
        console.log("getUserDetails response", response);

        console.log("Calling getUserDept");
        const userdep = await getUserDept();
        console.log("getUserDept response", userdep);

        if (response.success) {
          let existingPhone;
          try {
            const existing = JSON.parse(cookieData || "{}");
            existingPhone = existing?.user?.phone;
          } catch (e) {
            existingPhone = undefined;
          }

          const user = {
            ...response.result,
            user: {
              ...response.result.user,
              phone: (response.result.user && response.result.user.phone) || existingPhone,
              department: parseInt(userdep?.department || 0),
            },
          };

          setCookiesSession("LawSignaUserDataMaster", JSON.stringify(user), 2);

          setUserData(user.user);
          setConfig({ Loading: false });
        }
      } catch (error) {
        console.error(error);
        setConfig({ Loading: false });

        window.location.replace(`${process.env.REACT_APP_LANDING_URL}`);
      }
    };

    if (cookieData) {
      getDetails();
    } else {
      setConfig({ Loading: false });
      window.location.replace(`${process.env.REACT_APP_LANDING_URL}`);
    }
  }, []);

  return !config.Loading ? <>{children}</> : <p>Loading...</p>;
};

export default Home;
